import { constant as tmrFrontendCapabilities } from 'tmr/constants/frontendCapabilities';

tmrFrontendCapabilities[1].push.apply(tmrFrontendCapabilities[1], [
  'Operation.HandheldCustomLocateTag.perform'
]);

export const constant = [tmrFrontendCapabilities[0], tmrFrontendCapabilities[1]];
